export default "/arrow-down.8ce6a05ff6e9e281561e4890cf723a22.svg";